import { useParams,Link } from "react-router-dom";
import { servicedData } from "./constants";
import { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";



export default function Dynamic(props){

    const navigate = useNavigate();

    const [load,setload] = useState(false)

    useEffect(()=>{
        window.scrollTo(0,0);
    },[])

    async function handleClick(e,stringtoadd){
        e.preventDefault();
        if(props.bookdata.includes(stringtoadd)==false){
            setload(true);
            props.setBook(stringtoadd);
            await sleep(500);
            setload(false);
        }
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    const {test} = useParams();
    return <div className="dyn-div">
        {servicedData.map((data)=>{
            if(test==data.about){
                return <div className="dyn-data">
                    <img src={data.imgurl} className="dyn-img"/>
                    <div className="dyntext-div">
                        <div style={{flexDirection:"column",alignItems:"flex-start",gap:"2vw",display:"flex"}}>
                            <h1 className="dyn-header">{data.about}</h1>
                            <p className="dyn-text">{data.Text}</p>
                        </div>
                        <div style={{display:"flex",gap:"2vw"}}>
                            <Link type="submit" key={props.bookdata} style={props.bookdata.includes(data.about)?{backgroundColor:"green",color:"white"}:null} className="sliderlink" onClick={(event)=>handleClick(event,data.about)}>{load?<HashLoader color="white" loading={load}/>:props.bookdata.includes(data.about)?"Added":"Add to Cart"}</Link>
                            <Link to="/book" className="sliderlink">Check Your Booking</Link>
                        </div>
                    </div>
                </div>
            }
        })}
    </div>
}